'use client';
import { Link } from '@/shared/ui/Link';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import { cva } from 'class-variance-authority';
import { ComponentProps, FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PREFETCH } from '@/shared/constants';

interface Props {
  className?: string;
  data: Array<{
    title: string;
    href?: string;
  }>;
  swiperBreakpoints?: ComponentProps<typeof Swiper>['breakpoints'];
}

export const Breadcrumbs: FC<Props> = ({ className, data, swiperBreakpoints }) => {
  return (
    <Swiper
      className={twMergeExt(cvaRoot(), className)}
      slidesPerView={'auto'}
      spaceBetween={8}
      breakpoints={swiperBreakpoints}
      enabled={false}
    >
      {data.map((i, index) => (
        <SwiperSlide key={index} className={cvaItem()}>
          {i.href ? (
            <Link className={'whitespace-nowrap'} href={i.href} hoverEffect={'color'} prefetch={PREFETCH.BREADCRUMBS}>
              {i.title}
            </Link>
          ) : (
            <span className={'whitespace-nowrap'}>{i.title}</span>
          )}
          {index !== data.length - 1 ? <div className={cvaSeparator()} /> : null}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const cvaRoot = cva([
  'Breadcrumbs-cvaRoot',
  'flex flex-wrap items-center',
  'text-bodyXS text-cBlack48',
  '[&>div]:flex-nowrap md:[&>div]:flex-wrap',
  '[&>div]:w-[calc(100%-5.6rem)]',
]);

const cvaItem = cva(['Breadcrumbs-cvaItem', 'flex items-center gap-0.8', '!w-min']);

const cvaSeparator = cva(['Breadcrumbs-cvaSeparator', 'w-1 h-0.1', 'bg-cBlack16']);
